import React from "react";
import { Text14, Text15, Text7 } from "./styles";
import { ViewFullReportItem } from "./ViewFullReportItem";
import { Divider } from "antd";
import { useApp } from "../../contexts";
import { UserGroupIcon } from "../Icons/UserGroupIcon";
import { LinkIcon } from "../Icons/LinkIcon";
import { useNavigate } from "react-router-dom";
import { AFFILIATE_LINKS } from "../../constants";

export const ViewFullReport = ({ mlmUrl }) => {
  const { T } = useApp();
  const navigate = useNavigate();
  const handleRedirect = (link) => {
    window.open(link, "_blank");
  };
  return (
    <div className="w-[100%]">
      {/* <div className="text-right w-[42%] hidden lg:block">
        <Text15>{T("View Full Report")}</Text15>
      </div> */}
      <div className="mt-5 lg:mt-[35px] w-full flex flex-col lg:flex-row lg:gap-x-12 xls:gap-x-16">
        <div className="w-full lg:w-[33%]">
          <div onClick={() => handleRedirect(mlmUrl)}>
            <ViewFullReportItem
              title={T("AI Avatar Affiliate Management")}
              content={T("Manage members, placement and more")}
              icon={<UserGroupIcon />}
            />
          </div>
          <Divider className="mt-2 mb-3 lg:mb-7" />
        </div>
        <div className="w-full lg:w-[33%]">
          <div
            onClick={() =>
              handleRedirect(AFFILIATE_LINKS.TRACKER)
            }
          >
            <ViewFullReportItem
              title={T("AI Avatar Tracker")}
              content={T("Track & manage affiliate links")}
              icon={<LinkIcon />}
            />
          </div>
          <Divider className="mt-2 mb-3 lg:mb-7" />
        </div>
        <div className="w-full lg:w-[33%]">
          <div
            onClick={() =>navigate('/affiliate/generate-links')}
          >
            <ViewFullReportItem
              title={T("Generate Affiliate Links")}
              content={T("Generate new affiliate links at your convenience")}
              icon={<LinkIcon />}
            />
          </div>
          <Divider
            className="hidden lg:block"
            style={{ marginTop: 8, marginBottom: 0 }}
          />
        </div>
      </div>
    </div>
  );
};
